import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [NgbModule, ReactiveFormsModule, RouterModule],
  exports: [FormsModule, CommonModule, NgbModule, ReactiveFormsModule, RouterModule, TranslateModule],
})
export class MwSharedLibsModule {
  static forRoot(): ModuleWithProviders<MwSharedLibsModule> {
    return {
      ngModule: MwSharedLibsModule,
    };
  }
}
